/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// TODO: Add loading component
export default function AsyncComponentFactory(component) {
  return () => ({
    // The component to load (should be a Promise)
    component,
    // A component to use while the async component is loading
    // loading: LoadingComponent,
    // A component to use if the load fails
    // error: ErrorComponent,
    // Delay before showing the loading component. Default: 200ms.
    // delay: 200,
    // The error component will be displayed if a timeout is
    // provided and exceeded. Default: Infinity.
    // timeout: 3000,
  });
}
